export default __webpack_public_path__ + "static/brighter-future-844eeffcfc6dbee6a0fa075a52c410f8.png";